import { Link } from "react-router-dom";
import { BadgeCheck } from "lucide-react";

const initials = (n = "") => n.replace(/^(city|town|village|county|municipality|district|region|ville|municipalit[eé]) (of|de|du|d')\s*/i, "").split(/\s+/).filter((w) => /^[A-Za-zÀ-ÿ]/.test(w)).slice(0, 2).map((w) => w[0].toUpperCase()).join("");

export const OrgLogo = ({ name, logo, size = 32 }) => (logo
  ? <img src={logo} alt={`${name} logo`} loading="lazy" style={{ width: size, height: size }} className="shrink-0 rounded-lg border border-slate-300 bg-slate-100 object-contain p-0.5" />
  : <span style={{ width: size, height: size }} className="flex shrink-0 items-center justify-center rounded-lg bg-[#1E3A8A] text-xs font-bold text-white" aria-hidden="true">{initials(name)}</span>);

export const VerifiedBadge = ({ reasons = [], testId }) => (
  <span title={reasons.join(" · ") || "Verified Organization"} data-testid={testId}
    className="verified-badge inline-flex shrink-0 items-center gap-1 rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-semibold text-emerald-800">
    <BadgeCheck size={13} />Verified
  </span>
);

export const OrgLine = ({ o, label = "Source", testId = "org-line" }) => (
  <div className="flex items-center gap-2" data-testid={testId}>
    <OrgLogo name={o.organization} logo={o.org_logo} size={28} />
    <p className="min-w-0 text-sm text-slate-700"><span className="text-slate-500">{label}: </span>
      <Link to={`/organizations/${o.org_slug}`} className="font-semibold text-sky-800 hover:underline" data-testid={`${testId}-link`}>{o.organization}</Link></p>
    {o.org_verified && <VerifiedBadge reasons={o.org_verification} testId={`${testId}-verified`} />}
  </div>
);

export const ViaNote = ({ o }) => (o.via_aggregator
  ? <p className="mt-2 text-[11px] text-slate-500" data-testid="via-aggregator-note">No direct organization link found — listing via Volunteer Connector</p> : null);
